<template>
  <div class="dashboard__card dashboard__card--no-min" v-cloak>
    <CardLoading v-if="loading"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loading }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Accounts</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--library"> <span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span></div>
      </div>
      <Accounts></Accounts>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import Accounts from '../practice-info/Accounts.vue';

  export default {
    name: 'PracticeInfoCard',
    components: {
      CardLoading,
      Accounts,
    },
    computed: {
      ...mapGetters('accounts', { 'accountsLoading': 'loaders'  }),
      loading() {
        return this.accountsLoading.accounts;
      },
    },
  };
</script>
